import * as R from "ramda";

export const isEmpty = R.either(R.isNil, R.isEmpty);
